import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router'
import { KeyRound } from 'lucide-react'
import './AuthLayout.scss'

export default function AuthLayout() {
  const { t } = useTranslation()
  return (
    <div className="auth-page">
      <aside className="brand-panel">
        <div className="decor decor-a" />
        <div className="decor decor-b" />
        <div className="logo-row">
          <div className="mark">
            <KeyRound size={15} strokeWidth={2} />
          </div>
          <span className="wordmark">{t('brand.name')}</span>
        </div>
        <div className="spacer" />
        <div className="tagline-box">
          <p className="tagline">{t('auth.tagline')}</p>
          <p className="tagline-sub">{t('auth.taglineSub')}</p>
        </div>
      </aside>
      <main className="form-area">
        <div className="form-column">
          <Outlet />
        </div>
        <p className="copyright">{t('brand.copyright')}</p>
      </main>
    </div>
  )
}
